export { Icon } from './Icon';
export type { IconName } from './Icon';
